import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import BracketGamePredictionModel from "../Prediction/BracketGamePredictionModel";

export default class BracketGameRankingsModel {
  public meta: MetaModel = new MetaModel();
  public data: BracketGamePredictionModel[] = [];
}
